<nav aria-label="breadcrumb" class="no-print">
    <ol class="breadcrumb py-2 px-3 mb-2">
        @for (element of elements; track element; let last = $last) {
            @if (last) {
                <li class="breadcrumb-item active">
                    {{element.title}}
                </li>
            } @else {
                <li class="breadcrumb-item">
                    <a href="" (click)="setFolder($event, element)">{{element.title}}</a>
                </li>
            }
        }
    </ol>
</nav>
